import React from "react";
import Slider from "./Slider";

const MarketPlaces = () => {
  const projectsDataArray = [
    {
      name: "DHA",
      location: "Another Location 4",
      area: "3 kanal",
      image: "/assets/images/DH.jpg",
      features: [
        "Private pool",
        "7 bedrooms",
        "Eight bathrooms",
        "Lawn",
        "Library",
        "Four-car garage",
      ],
    },

    {
      name: "Etihad town ",
      location: "Sample Location 5",
      area: "1.5 kanal",
      image: "/assets/images/etihad.jpg",
      features: [
        "Jacuzzi",
        "5 bedrooms",
        "Six bathrooms",
        "Outdoor kitchen",
        "Home office",
        "Carport",
      ],
    },

    {
      name: "KT ",
      location: "Sample Location 5",
      area: "1.5 kanal",
      image: "/assets/images/KT.jpg",
      features: [
        "Jacuzzi",
        "5 bedrooms",
        "Six bathrooms",
        "Outdoor kitchen",
        "Home office",
        "Carport",
      ],
    },
    {
      name: "Lake City ",
      location: "Dha Phase 6 Block J",
      area: "1 kanal",
      image: "/assets/images/lake-city.jpg",
      features: [
        "Full Basement",
        "5 bedrooms",
        "Six bathrooms",
        "Spacious garden",
        "Modern kitchen",
        "Garage for two cars",
      ],
    },

    {
      name: "NLC ",
      location: "Another Location",
      area: "2 kanal",
      image: "/assets/images/NLC.jpg",
      features: [
        "Swimming Pool",
        "6 bedrooms",
        "Seven bathrooms",
        "Large backyard",
        "Home theater",
        "Three-car garage",
      ],
    },

    {
      name: "SERENA 1 ",
      location: "Sample Location 3",
      area: "0.5 kanal",
      image: "/assets/images/Serena-1.jpg",
      features: [
        "Spacious living room",
        "4 bedrooms",
        "Four bathrooms",
        "Walk-in closet",
        "Patio",
        "Two-car garage",
      ],
    },
    {
      name: "ZC ",
      location: "Sample Location 3",
      area: "0.5 kanal",
      image: "/assets/images/ZC.jpg",
      features: [
        "Spacious living room",
        "4 bedrooms",
        "Four bathrooms",
        "Walk-in closet",
        "Patio",
        "Two-car garage",
      ],
    },
    {
      name: "Bahria ",
      location: "Sample Location 3",
      area: "0.5 kanal",
      image: "/assets/images/Bahria.jpg",
      features: [
        "Spacious living room",
        "4 bedrooms",
        "Four bathrooms",
        "Walk-in closet",
        "Patio",
        "Two-car garage",
      ],
    },
  ];
  return (
    <div>
      <p className="text-center text-[24px] text-black p-4 font-semibold">
        Discover more about Pakistan real estate market
      </p>
      <div className="py-8 ">
        <Slider />
      </div>
    </div>
  );
};

export default MarketPlaces;
